import script from "./DepositByAccountsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DepositByAccountsTable.vue?vue&type=script&setup=true&lang=js"

import "./DepositByAccountsTable.vue?vue&type=style&index=0&id=13cb70b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13cb70b2"]])

export default __exports__